import styled from '@emotion/styled';
import { DropdownMenu, tokens, Loader } from '@hotjar/hotsauce';
import type { ComponentProps, ElementRef } from 'react';
import { forwardRef } from 'react';
import type { Site } from '@hotjar/navigation/src/types';

export interface SiteItemProps
  extends Omit<ComponentProps<typeof DropdownMenu.BaseItem>, 'children'> {
  site: Site;
  isLoading?: boolean;
}

const TextWrapper = styled.span<{ isSelected?: boolean }>`
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  color: ${({ isSelected }) => (isSelected ? tokens.color.primary_cta : 'inherit')};
`;

export const SiteItem = forwardRef<ElementRef<typeof DropdownMenu.BaseItem>, SiteItemProps>(
  ({ site, isSelected, as = 'a', isLoading, ...props }: SiteItemProps, ref): JSX.Element => (
    <DropdownMenu.BaseItem
      as={as}
      {...props}
      isSelected={isSelected}
      aria-current={isSelected ? 'true' : 'false'}
      ref={ref}
    >
      {isLoading ? <Loader css={{ marginRight: tokens.spacer.x1 }} size="m" /> : null}
      <TextWrapper isSelected={isSelected}>{site.name}</TextWrapper>
    </DropdownMenu.BaseItem>
  ),
);

SiteItem.displayName = 'SiteItem';
